import { PlannedPowerMeterCreatePayload, PlannedPowerMeterModel, PlannedPowerMeterSavePayload, PowerMeterForm } from 'src/Libs/installations/models'
import { getPlannedPowerMeterType } from './power-meter-type'

export const createPowerMeterPayload = (data: PowerMeterForm): PlannedPowerMeterCreatePayload => {
  const selectedPowerMeterType = getPlannedPowerMeterType(data.deviceType)
  const payload: PlannedPowerMeterCreatePayload = {
    number: data.index,
    deviceName: data.name,
    media: 'ModbusTCP',
    deviceType: selectedPowerMeterType ?? 'InternalRoot',
    typeParameters: {},
    wiringMode: data.wiringMode,
    ...(data.serialNumber !== undefined && { mediaParameters: { serialNumber: data.serialNumber.trim() || null } }),
  }

  return payload
}

export const createSavePowerMeterPayload = (data: PowerMeterForm, powermeter: PlannedPowerMeterModel): PlannedPowerMeterSavePayload => {
  const plannedPowerMeter = powermeter
  const selectedPowerMeterType = getPlannedPowerMeterType(data.deviceType)

  const payload: PlannedPowerMeterSavePayload = {
    number: data.index,
    deviceName: data.name,
    media: 'ModbusTCP',
    deviceType: selectedPowerMeterType ?? (plannedPowerMeter.deviceType || 'InternalRoot'),
    typeParameters: plannedPowerMeter.typeParameters,
    wiringMode: data.wiringMode,
    ...(data.serialNumber !== undefined && { mediaParameters: { serialNumber: data.serialNumber.trim() || null } }),
  }

  return payload
}

export const getNextAvailableAddress = (meters: Nullable<PlannedPowerMeterModel>[]): number | null => {
  const usedAddresses = new Set(
    meters.map(meter => meter?.mediaParameters?.address).filter((address): address is number => typeof address === 'number')
  )

  for (let address = 1; address <= 255; address++) {
    if (!usedAddresses.has(address)) return address
  }

  return null
}
